// extracted by mini-css-extract-plugin
export default {"followButton":"U6-z","followCount":"V6-z","textStyle":"W6-z"};